export default __webpack_public_path__ + "static/media/performance_overview.433a5c7f.svg";